/**
 * Helpers para construcción de URLs de navegación
 * Centraliza la lógica de construcción de URLs para el navbar y menús
 */

/**
 * URLs externas que no necesitan prefijo de idioma
 */
const EXTERNAL_URL_PATTERNS = ['https', '#', '/es/', '/en/'];

/**
 * Rutas especiales que no usan el patrón bilingüe estándar
 */
const SPECIAL_ROUTES = ['/solutions', '/soluciones', '/solutions/ai-adoption', '/solutions/ai-integration','/soluciones/integracion-ia','/soluciones/adopcion-ia','/solutions/agents','/soluciones/agentes', '/solutions/data', '/soluciones/data'];

/**
 * Verifica si una URL es externa o especial
 */
export const isExternalOrSpecialUrl = (href) => {
  if (!href) return false;
  return (
    EXTERNAL_URL_PATTERNS.some(pattern => href.includes(pattern)) ||
    SPECIAL_ROUTES.includes(href)
  );
};

/**
 * Construye la URL completa para un link del navbar
 * @param {string} href - URL base del link
 * @param {string} actualLang - Idioma actual ('en' o 'es')
 * @returns {string} URL completa con prefijo de idioma si es necesario
 */
export const buildNavbarUrl = (href, actualLang) => {
  if (!href) return '';
  
  // Si es URL externa o ruta especial, devolver tal cual
  if (isExternalOrSpecialUrl(href)) {
    return href;
  }
  
  // Agregar prefijo de idioma para rutas internas
  const langPrefix = actualLang === 'en' ? 'en-en' : 'es-es';
  return `/${langPrefix}${href}`;
};

/**
 * Construye la URL completa para un link dentro del MegaMenu
 * @param {string} linkHref - URL del link específico
 * @param {string} parentHref - URL del item padre
 * @param {string} actualLang - Idioma actual ('en' o 'es')
 * @returns {string} URL completa
 */
export const buildMegaMenuLinkUrl = (linkHref, parentHref, actualLang) => {
  if (!linkHref) return null;
  
  // Si el link es externo, devolver tal cual
  if (linkHref.includes('https')) {
    return linkHref;
  }
  
  // Si no hay parent href, no se puede construir la URL
  if (!parentHref) {
    return null;
  }
  
  // Construir URL: /{lang}{parentHref}/{linkHref}
  const langPrefix = actualLang === 'en' ? 'en-en' : 'es-es';
  return `/${langPrefix}${parentHref}/${linkHref}`;
};

/**
 * Obtiene el prefijo de idioma para URLs
 */
export const getLangPrefix = (actualLang) => {
  return actualLang === 'en' ? 'en-en' : 'es-es';
};

